import { useEffect } from 'react'
import { useNavigationType } from 'react-router-dom'
import usePageNav from 'src/hooks/usePageNav.hook'
import usePathMatch from 'src/hooks/usePathMatch.hook'

// 뒤로가기 제어가 필요 한경우
const useNavigationTypeReplace = () => {
  const navigationType = useNavigationType()
  const { navigatePrev } = usePageNav()
  const { match_self_register } = usePathMatch()

  // navigate replace: true 로 이동하는 경우
  useEffect(() => {
    if (navigationType === 'REPLACE' && match_self_register) {
      navigatePrev()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigationType])
}
export default useNavigationTypeReplace
